import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'pitem',
    templateUrl: './paper-item.component.html',
    styleUrls: ['./paper-item.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaperItemComponent {
}



// WEBPACK FOOTER //
// ./src/app/components/polymer/paper-item/paper-item.component.ts